<template>
<v-layout row wrap justify-center align-center no-gutters class="mt-0 color-menu">
  <v-flex xs12 ma-0 class="pa-0 menu-initial">

      <div class="d-flex mx-auto justify-space-between align-center" style="width:100%;">
        <v-btn icon small class="ma-1" elevation="0" v-if="$vuetify.breakpoint.xs" @click="drawer = true" >
          <v-icon color="#005487"> mdi-dots-vertical-circle-outline</v-icon>
        </v-btn>

        <div class="cont-logo" @click="openRuta('inicio', 0)">
          <img src="@/assets/imagenes_compartidas/logo-narradores.png" alt="">
        </div>
        <div class="menu-contenidos" v-if="!$vuetify.breakpoint.xs">
          <div class="item-menu" @click="openRuta('inicio', 0)" :style="estadoMenu[0] ? 'border-top:solid 5px #0B542D;color: #0B542D;' : ''"> Inicio</div>
          <div class="item-menu" @click="openRuta('adaptaclima', 1)" :style="estadoMenu[1] ? 'border-top:solid 5px #0B542D;color: #0B542D;' : ''"> AdaptaClima </div>
          <div class="item-menu" @click="openRuta('conoceRiesgos', 2)" :style="estadoMenu[2] ? 'border-top:solid 5px #0B542D;color: #0B542D;' : ''"> Conoce los riesgos </div>
        </div>
        <v-navigation-drawer
          v-model="drawer"
          fixed
          temporary
        >
          <v-list nav dense >
            <v-list-item-group
              v-model="group"
              active-class="text--accent-4"
            >
              <v-list-item @click="openRuta('inicio')">
                <v-list-item-title><span>INICIO</span></v-list-item-title>
              </v-list-item >
              <v-list-item @click="openRuta('adaptaclima')">
                <v-list-item-title><span>AdaptaClima </span></v-list-item-title>
              </v-list-item>
              <v-list-item @click="openRuta('conoceRiesgos')">
                <v-list-item-title><span>Conoce los riesgos</span></v-list-item-title>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-navigation-drawer>

        <div class="pr-2" v-if="verRedes">
          <v-btn v-for="(red , n ) in dataRedes"
          :key="'red-'+n" small
           color="#005487" icon link :href="red.enlace" target="_blank">
           <v-img width="20px" :alt="red.identificador" aspect-ratio="1" :src="$store.state.rutaApi+red.icono"></v-img>
          </v-btn>
        </div>
      </div>
      <div class="borde-imagen"></div>
  </v-flex>

</v-layout>
</template>
<script>
import axios from 'axios'
export default {
  name : "navUser",
  data() {
    return {
      drawer: false,
      group: null,
      aItems: [],
      itemsB:[],
      textPrueba:'',
      removeAccents:'',
      drawer: false,
      menu: [],
      dataRedes:null,
      verRedes:false,
      estadoMenu: [true,false,false]
    }
  },
  computed:{
  },
  async mounted() {
    await axios
    .get(''+this.$store.state.rutaApi+'redes')
    .then(response => (this.dataRedes  = response.data))
    this.verRedes = true

  },
  methods: {
    openRuta(val, pos) {
      this.estadoMenu = Array(3).fill(false)
      this.$set(this.estadoMenu, pos, true)

      if (this.$route.name === val && pos === 0) {
        // You're already on the same route — force refresh
        window.location.reload()
      } else {
        this.$router.push({ name: val })
      }
    }
    }
  }
</script>
<style lang="scss" scoped>

.menu-contenidos{
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: stretch;

  .item-menu{
    color: #003556;
    margin: 2px 10px;
    cursor: pointer;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 3!important;
  }
}
.borde-imagen{
  background: url('../assets/imagenes_compartidas/borde-imagen.png')no-repeat;
  background-size: cover;
  background-position: bottom center;
  height: 10px;
  width: 100%;
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 2;
}

.menu-initial{
  background: #FFFFFF;
  // border-bottom: #005487 solid 5px;
  position: relative;
}

.cont-general-menu{
  padding: 0px!important;
}
.cont-logo{
  cursor: pointer;
  padding: 5px;
  background: white;
  margin-left: 30px;
  img{
    height: 50px;
  }
}

.color-menu{
  min-height: 50px;
  width: 100%;
  background: #F3F3F4;
  transition: all 0.3s ease-in-out;
}

.btn-itemh{
  max-height: 40px;
  font-size: 0.7em!important;
  color: #2B5AC4;
}

.itemHorizonal{
  display: inline-block;
}
.bdred{
  border: solid red 1px;
}
.texto-menu{
  font-size: 1em;
  color: var(--v-primary-base);
  font-weight: 600;
}
.cont-item-menu{
  min-height: 30px!important;
}
.boton-menu{
  padding: 0px 5px!important;
  min-width: 30px;
  letter-spacing: 0;
}
.cont-logo-resp{
  background: rgba(16,134,255,1);
}
.boton-menu-responsive{
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.menu-initial{
  transition: all 0.3s ease-in-out;
}
.pos-drawer{
  z-index: 1;
}
.cont-boton{
  width: 100%;
  background: #F3F3F4;
}
.boton-burguer{
  position: absolute;
  left: 0;
  top: 0px;
  z-index: 1;
}
</style>
